/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import * as controller from './controller';

export default (router) => {
    router(`/dashboard/subscriptions`, controller.subscriptions, makeLayout, render);
    router(`/dashboard/subscriptions/new`, controller.newSubscription, makeLayout, render);
};
